import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const DEFAULT_LIMIT_OPTIONS = [10, 20, 50, 100];

interface PaginationBarProps {
  hasPrevious: boolean;
  hasNext: boolean;
  isLoading?: boolean;
  limit: number;
  limitOptions?: number[];
  onPrevious: () => void;
  onNext: () => void;
  onLimitChange: (limit: number) => void;
}

export function PaginationBar({
  hasPrevious,
  hasNext,
  isLoading,
  limit,
  limitOptions = DEFAULT_LIMIT_OPTIONS,
  onPrevious,
  onNext,
  onLimitChange,
}: PaginationBarProps) {
  return (
    <div className="flex items-center justify-between pt-4">
      <Button
        variant="outline"
        size="sm"
        onClick={onPrevious}
        disabled={!hasPrevious || isLoading}
      >
        <ChevronLeftIcon className="size-4" />
        Previous
      </Button>

      <div className="flex items-center gap-2 text-sm">
        <span className="text-muted-foreground">Rows per page</span>
        <Select
          value={String(limit)}
          onValueChange={(value) => onLimitChange(Number(value))}
        >
          <SelectTrigger size="sm" className="w-[70px]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {limitOptions.map((option) => (
              <SelectItem key={option} value={String(option)}>
                {option}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <Button
        variant="outline"
        size="sm"
        onClick={onNext}
        disabled={!hasNext || isLoading}
      >
        Next
        <ChevronRightIcon className="size-4" />
      </Button>
    </div>
  );
}
